import { render } from "./FeesDashboard.vue?vue&type=template&id=d2b0902c&scoped=true"
import script from "./FeesDashboard.vue?vue&type=script&lang=js"
export * from "./FeesDashboard.vue?vue&type=script&lang=js"

import "./FeesDashboard.vue?vue&type=style&index=0&id=d2b0902c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b0902c"]])

export default __exports__